/** @jsxImportSource @emotion/react */

import { useTheme } from '../../ThemeProvider';
import { Input, InputProps } from '../Input';

export type Props = InputProps;

export const UtilityInput = ({ icon, ...props }: Props) => {
  const { spacing } = useTheme();
  return (
    <Input
      {...props}
      icon={icon}
      css={{
        '.MuiOutlinedInput-root': {
          input: {
            padding: `${spacing.xxxs} ${spacing.xxxs} ${spacing.xxxs} ${
              icon ? '0px' : spacing.xxxs
            }`,
          },
        },
      }}
    />
  );
};
